import { Component, OnDestroy, OnInit } from '@angular/core';
import { DadosLoginService } from '@auth/services/dados-login.service';
import { NgbDropdownConfig } from '@ng-bootstrap/ng-bootstrap';
import { HomeSidebarService } from '@services/home-sidebar.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { SideMenu } from 'src/app/models';
import { SeletorProjetosService } from '../seletor-projetos/seletor-projetos.service';
import { SidebarLinksService } from '../sidebar-links.service';
/*
    Declaração do Jquery
*/
declare var $: any;

@Component({
    selector: 'app-home-sidebar',
    templateUrl: './home-sidebar.component.html',
    styleUrls: ['./home-sidebar.component.css'],
    providers: [NgbDropdownConfig],
})
export class HomeSidebarComponent implements OnInit, OnDestroy {
    sidebar_active;
    colaborador;
    links: SideMenu[] = [];
    linksAtualizados;
    sidebar$;
    private dadosLoginSub$: Subscription;

    constructor(
        private apiSidebar: HomeSidebarService,
        public dadosLoginService: DadosLoginService,
        private spinner: NgxSpinnerService,
        private toastr: ToastrService,
        public sidebarLinksService: SidebarLinksService,
        private seletorProjetosService: SeletorProjetosService,
        config: NgbDropdownConfig
    ) {
        config.placement = 'bottom-left';
    }

    ngOnInit() {
        this.loadSidebar();
        this.loadDadosLogin();
        this.loadLinks();
        this.loadProjeto();
    }

    private loadSidebar() {
        this.sidebar$ = this.apiSidebar.getStatus().subscribe(status => {
            this.sidebar_active = status;
        });
    }

    private loadLinks() {
        this.sidebarLinksService.links$.subscribe(links => {
            this.links = links;
        });
    }

    private loadProjeto() {
        this.seletorProjetosService.projeto$.subscribe(projeto => {
            if (!projeto) {
                return;
            }
            const linkReq = this.links.find(el => el.id === 'requisicoes');
            if (linkReq === undefined) return;
            const query = linkReq.submenus.find(
                el => el.id === 'requisicoes-autorizar'
            ).query;
            if (query === undefined) return;
            query.titulo_curto = projeto.titulo_curto;
        });
    }

    private loadDadosLogin() {
        this.spinner.show('sidebar');
        this.dadosLoginSub$ = this.dadosLoginService.dadosLogin$.subscribe({
            next: dadosLogin => {
                this.colaborador = dadosLogin?.dados;
                this.spinner.hide('sidebar');
            },
            error: () => {
                this.spinner.hide('sidebar');
            },
        });
    }

    ngAfterViewInit(): void {
        $('#collapseGroup').on(
            'show.bs.collapse',
            '.collapse',
            (event: any) => {
                const mainNavigation = $(event.target).prev(
                    'a[data-menu="main"]'
                );
                if (mainNavigation.length) {
                    $('#collapseGroup .collapse')
                        .not(event.target)
                        .collapse('hide');
                }
            }
        );
    }

    ngOnDestroy() {
        this.sidebar$.unsubscribe();
        this.dadosLoginSub$?.unsubscribe();
    }

    onSelect() {
        this.apiSidebar.updateStatus(false);
    }
}
